import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { convertDateToPattern as dateFormat } from "../../helpers"

export function useReservation(applicationData: any, api: any) {
  const navigate = useNavigate()

  const [thereIsATour, setThereIsATour] = useState(true)

  const [origin, setOrigin] = useState("0")
  const [destiny, setDestiny] = useState("0")
  const [client, setClient] = useState(
    applicationData.acesso !== "funcionario" ? applicationData.funcionario : "0"
  )

  const [going, setGoing] = useState(new Date())
  const [comeBack, setComeBack] = useState<Date | string>("")

  const [amountOfAdults, setAmountOfAdults] = useState<string>("1")
  const [amountOfChildren, setAmountOfChildren] = useState<string>("")

  const [goingData, setGoingData] = useState<Passeios | null>(null)
  const [comeBackData, setComeBackData] = useState<Passeios | null>(null)

  const [choiceGoing, setChoiceGoing] = useState<number | string>("")
  const [choiceComeBack, setChoiceComeBack] = useState<number | string>("")

  const [enableButton, setEnableButton] = useState(true)

  const [barco, setBarco] = useState("0")

  const [dataInicial, setDataInicial] = useState<Date | string>("")
  const [dataFinal, setDataFinal] = useState<Date | string>("")

  const [passengers, setPassengers] = useState<Passengers>({
    adults: [
      {
        name: "",
        tel: ""
      }
    ],
    children: []
  })

  useEffect(() => {
    if (goingData || comeBackData) {
      setThereIsATour(true)
    } else {
      if (origin !== "0" && destiny !== "0") setThereIsATour(false)
    }
  }, [comeBackData, destiny, goingData, origin])

  const handleSeekTour = async (
    setState: React.Dispatch<React.SetStateAction<Passeios | null>>,
    date: Date,
    originId: string,
    destinyId: string
  ) => {
    try {
      const data = await api.passeios(applicationData.token, {
        origin: originId,
        destiny: destinyId,
        date: dateFormat(date)
      })

      if (data.length > 0) {
        setState(data)
      }
    } catch (error: any) {
      if (error.response?.statusText === "Token expired [EMVCJWTException]") {
        navigate("/login")
      }
    }
  }

  const generateTourTitle = (passeios: Destinos, codigo: string) => {
    const [result] = passeios.filter(
      (passeio: Destino) => passeio.codigo === Number(codigo)
    )

    return result.nome
  }

  const updatesAdultPassengerData = (
    index: number,
    key: string,
    value: string
  ) => {
    return passengers.adults.map((adult, i) => {
      if (index === i) return { ...adult, [key]: value }
      else return adult
    })
  }
  const updatesChildrenPassengerData = (
    index: number,
    key: string,
    value: string
  ) => {
    return passengers.children.map((child, i) => {
      if (index === i) return { ...child, [key]: value }
      else return child
    })
  }

  const updatesAllOfThePassengers = (passengers: Passengers) => {
    setPassengers(passengers)
  }

  const resetReservation = () => {
    setOrigin("0")
    setDestiny("0")
    setClient(applicationData.acesso !== "funcionario" ? applicationData.funcionario : "0")
    setAmountOfAdults("0")
    setGoing(new Date())
    setComeBack("")
    setAmountOfAdults("1")
    setAmountOfChildren("")
    setGoingData(null)
    setComeBackData(null)
    setChoiceGoing("")
    setChoiceComeBack("")
    setPassengers({
       adults: [{ name: "", tel: "" }],
      children: []
    })
    setThereIsATour(true)
    setEnableButton(true)
  }

  return {
    navigate,
    origin,
    setOrigin,
    destiny,
    setDestiny,
    client,
    setClient,
    going,
    setGoing,
    comeBack,
    setComeBack,
    amountOfAdults,
    setAmountOfAdults,
    amountOfChildren,
    setAmountOfChildren,
    goingData,
    setGoingData,
    comeBackData,
    setComeBackData,
    choiceGoing,
    setChoiceGoing,
    choiceComeBack,
    setChoiceComeBack,
    enableButton,
    setEnableButton,
    barco,
    setBarco,
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal,
    passengers,
    setPassengers,

    handleSeekTour,
    generateTourTitle,
    updatesAdultPassengerData,
    updatesChildrenPassengerData,
    updatesAllOfThePassengers,

    thereIsATour,
    setThereIsATour,

    resetReservation
  }
}
